module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "chapnum"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("1.")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('h3', {
    staticClass: "chaptitle"
  }, [_vm._v("PEOPLE IN CONTEXT")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“You’re missing the context of my thoughts. Don’t misinterpret.”")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("—enlatia, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pandemiconium: Viral Conspiracy")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "alt": "images",
      "src": "images/fig3.jpg"
    }
  })])]), _c('h3', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("People in Context, Thoughts in Context, Understanding Context")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("I am referring to the people or groups that are interacting within a particular context. For example, perhaps the context is social, historical, cultural, global, or educational in nature. Context is the framework by which people interact. Context affects how a person may perceive or react to things. We are all in context on both macro and micro levels. We may find ourselves in a particular political, cultural, and/or economic context throughout our day, but if we go to a party, we might find ourselves in a micro context of “a party with strangers.” At the same time, we carry some deep-rooted context that we consider part of our identity. We also encounter new contexts that we must navigate.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Context can be affected by and may include many things, such as environment, place, nature, and objects. Still, it can also include things that are less tangible, like biases, perceptions, abilities, beliefs, money, constraints, culture, customs, emotions, decisions that have been made, habits, goals, health, income, identity, family beliefs and structure, language, social cues, media, and so on.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The use of context is powerful when making judgments and understanding. It is deeply embedded in our communication, the words we choose, and how we define things around us. It helps us decide how we will act in certain situations. For example, we may act one way at work but another when out with friends. We may use different languages, dress differently, relate to people differently, and so on. We may use context to create self-definitions, such as “I am unhealthy, I am poor, I am uneducated,” etc.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("The reality we choose to acknowledge is a construct of context. If you had a different context, you might interpret the world in a vastly different way. For example, if you time-traveled to a hundred years in the future, you might recognize certain things, but your context would be from a hundred years earlier. You would be experiencing that time through a lens from the distant past.")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Why does this matter to us? Throughout this book, we will be discussing feelings and perceptions. It is important to understand that context is different for everyone and at different times. Understanding context can help you interact effectively and with more care. It can give you insight into the person you are trying to help. It can help you articulate your feelings in a way that makes you feel heard.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Understanding the context of another person allows you to come to them in a place that is in between or be able to meet them where they are. You have a better chance of being heard if you can do this. If you can do this, you can find empathy and compassion. If you cannot meet someone where they are, you will struggle to be understood and heard. Your words may be understandable, but they won’t land where you want them to.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Knowing this can help you identify and understand different beliefs, emotions, understandings, patterns, and responses that shape conversations. In short, it helps us improve our communication with others because it is a tool we can use to foster compassion, empathy, understanding, and commonality.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("We can even cling to context so tightly that we cannot see other realities, viewpoints, and perspectives. Very strict cultural or religious beliefs can blind us to parts of ourselves and others that are rich and valuable.")])]), _c('div', {
    staticClass: "box"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('h3', {
    staticClass: "title2"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Exercise")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("What are the context frameworks that define your landscape? Can you make a list? How do they relate to your beliefs, emotions, definitions, and actions? When does context change for you? How does that change feel?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Start noticing others and the context frameworks they might be working in. Is it possible to bridge the spaces where you differ to find a meaningful connection?")])])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20bbb528","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Chapter01.vue
// module id = 81
// module chunks = 0